import firebase from 'firebase/app';
import 'firebase/database';

import validarTipo from '../utils/validarTipo';

/**
 * Database
 *
 * @export
 * @class Database
 */
export default class Database {
  /**
   * getRef
   *
   * @static
   * @param {string} item
   * @returns {Object{firebase.database.ref}}
   * @memberof Database
   */
  static getRef(item) {
    if (!validarTipo(item, 'string') || item.length === 0) {
      return false;
    }
    try {
      const db = firebase.database();
      const ref = db.ref(`${item}`);

      return ref;
    } catch (e) {
      return false;
    }
  }

  /**
   * gravar
   *
   * @static
   * @param {string} chave
   * @param {any} dado
   * @returns {boolean}
   * @memberof Database
   */
  static async gravar(chave, dado) {
    if (!validarTipo(chave, 'string')) {
      return false;
    }
    if (!dado) {
      return false;
    }
    try {
      const ref = this.getRef(chave);
      await ref.set(dado);
      return true;
    } catch (e) {
      return false;
    }
  }

  /**
   * recuperar
   *
   * @static
   * @param {string} chave
   * @returns {any}
   * @memberof Database
   */
  static async recuperar(chave) {
    if (!validarTipo(chave, 'string')) {
      return false;
    }
    try {
      const ref = this.getRef(chave);
      const dado = await ref.once('value').then(snapshot => snapshot.val());
      return dado;
    } catch (e) {
      return false;
    }
  }

  static listener(chave, callback) {
    if (!validarTipo(chave, 'string')) {
      return false;
    }
    try {
      const ref = this.getRef(chave);
      ref.on('value', snapshot => {
        callback(snapshot.val());
      });
    } catch (e) {
      console.log(e);
      return false;
    }
  }

  /**
   * deletar
   *
   * @static
   * @param {string} chave
   * @returns {boolean}
   * @memberof Database
   */
  static async deletar(chave) {
    if (!validarTipo(chave, 'string')) {
      return false;
    }
    try {
      const ref = this.getRef(chave);
      await ref.remove(chave);
      return true;
    } catch (e) {
      return false;
    }
  }
}
